import { render, staticRenderFns } from "./TemplateDialog.vue?vue&type=template&id=9976e43a&scoped=true"
import script from "./TemplateDialog.vue?vue&type=script&lang=js"
export * from "./TemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateDialog.vue?vue&type=style&index=0&id=9976e43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9976e43a",
  null
  
)

export default component.exports